<template>
    <div class="flex">
        <!-- Hamburger button -->
        <button
            class="text-gray-500 hover:text-gray-600"
            @click.stop="isSidebarOpen = !isSidebarOpen"
            aria-controls="sidebar"
            :aria-expanded="sidebarOpen"
        >
            <span class="sr-only">Open sidebar</span>
            <svg
                class="w-6 h-6 fill-current"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="4" y="5" width="16" height="2" />
                <rect x="4" y="11" width="16" height="2" />
                <rect x="4" y="17" width="16" height="2" />
            </svg>
        </button>
    </div>
</template>
<script>
import { mapActions, mapState } from "pinia";
import { useAppStore } from "@/store/app";

export default {
    data: () => ({}),
    computed: {
        ...mapState(useAppStore, ["sidebarOpen"]),
        isSidebarOpen: {
            get() {
                return this.sidebarOpen;
            },
            set(value) {
                this.setSidebarOpen(value);
            },
        },
    },
    methods: {
        ...mapActions(useAppStore, ["setSidebarOpen"]),
    },
};
</script>
